import { LRLanguage, LanguageSupport } from "@codemirror/language";
import { parser } from "./parser";
import { mongoHighlighting } from "./highlight";

export const mongoLanguage = LRLanguage.define({
  parser: parser.configure({
    props: [mongoHighlighting],
  }),
  languageData: {
    commentTokens: { line: "//", block: { open: "/*", close: "*/" } },
    closeBrackets: { brackets: ["(", "[", "{", "'", '"'] },
  },
});

export function mongo() {
  return new LanguageSupport(mongoLanguage);
}
